import { useEffect } from 'react';

/**
 * Hook to clear the application cache using keyboard shortcuts:
 * - Windows: Ctrl + Alt + X
 * - Mac: Cmd + Option(⌥) + X
 */
export function useClearCache() {
  useEffect(() => {
    function handleKeyDown(event: any) {
      if (
        (event.ctrlKey || event.metaKey) &&
        (event.altKey || event.ctrlKey) &&
        (event.key === 'x' || event.key === '≈')
      ) {
        if (confirm('Are you sure you want to clear the cache?')) {
          localStorage.removeItem('tekstai-cache');
          window.location.reload();
        }
      }
    }

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, []);
}
